export default "__VITE_ASSET__DwuOIlOt__"